export enum CHAIN_ID {
  ARBITRUM_TESTNET = 421614,
  ARBITRUM_MAINNET = 42161,
  LINEA_TESTNET = 59141,
  LINEA_MAINNET = 59144,
  BASE_MAINNET = 8453,
  BSC_TESTNET = 97,
  BSC_MAINNET = 56,
  IMMUTABLE_ZKEVM_TESTNET = 13473,
  IMMUTABLE_ZKEVM_MAINNET = 13371,
}

export const TESTNET_CONTRACTS = {
  [CHAIN_ID.ARBITRUM_TESTNET]: {
    contractAddress: "",
    usdtAddress: "0x7a17Dd692bF26c1aD0ac69b7c8c449F610A0EbbC",
    usdcAddress: "0x59a2B520379BB6c048A2d4b9E33B5DC70AC7BBF8",
  },
  [CHAIN_ID.LINEA_TESTNET]: {
    contractAddress: "0x65f60c4c59BD9ae6CE5CF49443d34a84E6e39049",
    usdtAddress: "0x91Ede47c84e88dD416a771ED3222dfE8EB65462f",
    usdcAddress: "0x8b6d4a90D6bb1359ebB6bDbd5df0fc32D83696E0",
  },
  [CHAIN_ID.BSC_TESTNET]: {
    contractAddress: "0xD738E48b2D40511A515b840f162C33991a852316",
    usdtAddress: "0x30ED55dB4F7CD6829f01C8A224134Cbc21055555",
    usdcAddress: "0x74C93D2d06138457974447BDD6f15b337d8F6823",
    ethAddress: "0x0000000000000000000000000000000000000000",
  },
  [CHAIN_ID.IMMUTABLE_ZKEVM_TESTNET]: {
    contractAddress: "",
    usdtAddress: "",
    usdcAddress: "",
  },
};

export const MAINNET_CONTRACTS = {
  [CHAIN_ID.ARBITRUM_MAINNET]: {
    contractAddress: "",
    usdtAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    usdcAddress: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
  },
  [CHAIN_ID.BASE_MAINNET]: {
    contractAddress: "0xF07C95F7b5c27E81439512c5a513fEabCFa843D9",
    usdtAddress: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
    usdcAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
  },
  [CHAIN_ID.LINEA_MAINNET]: {
    contractAddress: "0x44dd0C2e368453FD66d66f1f542efee68c536dCf",
    usdtAddress: "0xA219439258ca9da29E9Cc4cE5596924745e12B93",
    usdcAddress: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
  },
  [CHAIN_ID.IMMUTABLE_ZKEVM_MAINNET]: {
    contractAddress: "",
    usdtAddress: "",
    usdcAddress: "",
  },
};
